import React from 'react';
import {
  Nav, 
} from 'reactstrap';
import bn from '../../utils/bemnames';
import * as S from './styled';
import icone1 from '../../assets/images/icone1.png';
import icone2 from '../../assets/images/icone2.png';

const Sidebar = () => {
  const bem = bn.create('sidebar');

  return (
    <S.DivTeste>
      <aside className={bem.b()} style={{ padding: '0' }} id="navbar">
        <div className={bem.e('background')} style={{ backgroundColor: '#000000'}} />
        <div className={bem.e('content')}>
          <Nav vertical>
            <S.Geral>
              <S.Linha />
              <S.Sombra>
                <S.Text>MENU</S.Text>
                <img src={icone1} alt="" />
                <img src={icone2} alt="" />
                <img src={icone1} alt="" />
                <img src={icone1} alt="" />
                <img src={icone1} alt="" />
                <img src={icone1} alt="" />
              </S.Sombra>
            </S.Geral>
          </Nav>
        </div>
      </aside>

    </S.DivTeste>
  );
}

export default Sidebar;